import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { onMainContentChange } from './components/animations/animations';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [onMainContentChange]
})
export class AppComponent {
  title = 'app';
  showFiller = false;
  currentUserLogged = null;
  minimizedNavSideMenu = true;
  actualRouter = "";
  appVersion = null;
  constructor(private _http: HttpClient, private _router: Router) {
    this._router.events.subscribe(val => {
      if (val instanceof NavigationEnd) {
        this.actualRouter = val.url;
        this.ngOnInit()
      }
    })
  }

  ngOnInit() {
    if (this.appVersion === null) {
      this._http.get("/" + "Authentication/getversion")
        .subscribe(
          (response) => {
            if (response) {
              this.appVersion = response["version"];
              this.loadUserLocalStorage();
            }
          }, (err) => { });
    } else {
      this.loadUserLocalStorage();
    }
  }

  loadUserLocalStorage() {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if ((currentUser && (!currentUser.version || currentUser.version != this.appVersion)) || (currentUser && currentUser.userPermission && currentUser.userPermission.managerHome == undefined)) {
      localStorage.setItem('currentUser', null);
      document.location.reload(true);
      return false;
    }

    this.currentUserLogged = currentUser; 
    
    return true;
  }

  toggle() {
    this.minimizedNavSideMenu = !this.minimizedNavSideMenu;
  }
}
